import { createSelector, Selector } from 'reselect';
import * as R from 'ramda';
import { selectCurrentCaseLodgmentsCountByTypeWithCustomDistribution } from '../../granulometry/currentCase/lodgmentsCountByTypeWithCustomDistribution.selector';
import { State } from '../../../../store/reducers';

export const selectLodgmentsCountWithCustomDistribution: Selector<State, number> = createSelector(
  [selectCurrentCaseLodgmentsCountByTypeWithCustomDistribution],
  R.pipe(R.valuesIn, R.sum)
);
